import React, { useMemo } from 'react';

// helpers
import { useEntityIntakeFormContext } from '../EntityIntakeFormContext';

// components
import Declined from './Declined';
import Returned from './Returned';
import Withdrawn from './Withdrawn';
import Submitted from './Submitted';
import StepsCard from 'components/Additional/StepsCard';
import UnderReview from './UnderReview';
import Accepted from './Accepted';
import Archived from './Archived';

const IntakeStatus = () => {
  const { steps, activeStepKey, intakeForm, selectStep } =
    useEntityIntakeFormContext();

  const contentNode = useMemo(() => {
    if (!activeStepKey || !intakeForm) {
      return null;
    }

    switch (activeStepKey) {
      case 'submitted':
        return <Submitted />;
      case 'under-review':
        return <UnderReview />;
      case 'withdrawn':
        return <Withdrawn />;
      case 'returned':
        return <Returned />;
      case 'declined':
        return <Declined />;
      case 'accepted':
        return <Accepted />;
      case 'archived':
        return <Archived />;
      default:
        return null;
    }
  }, [activeStepKey, intakeForm]);

  return (
    <StepsCard
      steps={steps}
      onSelect={selectStep}
      activeStep={activeStepKey}
      addOpacityToDisabledSteps={false}
    >
      {contentNode}
    </StepsCard>
  );
};

export default IntakeStatus;
